import template from './callUs.html';
import './callUs.scss';

class CallUsController {
    /*@ngInject*/ 
    constructor() {
    }
}

export default {
    template: template,
    bindings: {
        showGreenBackground: '<'
    },
    controller: CallUsController
};